export const EMAIL_TEMPLATE_TYPES = [
  'cold_outreach',
  'follow_up',
  'warm_introduction',
  'proposal',
  'meeting_request',
  'thank_you',
  'custom'
] as const;

export type EmailTemplateType = typeof EMAIL_TEMPLATE_TYPES[number];

export interface EmailTemplate {
  id: number;
  teamId: number;
  name: string;
  description?: string;
  type: EmailTemplateType;
  subject: string;
  content: string;
  isHtml: boolean;
  variables: string[];
  isActive: boolean;
  createdBy?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEmailTemplateData {
  name: string;
  description?: string;
  type: EmailTemplateType;
  subject: string;
  content: string;
  isHtml?: boolean;
  variables?: string[];
}

export interface UpdateEmailTemplateData extends CreateEmailTemplateData {
  isActive?: boolean;
}

export interface GenerateEmailContentData {
  templateId?: number;
  type: EmailTemplateType;
  leadData: {
    name?: string;
    company?: string;
    industry?: string;
    jobTitle?: string;
    website?: string;
    location?: string;
  };
  senderData: {
    name: string;
    company: string;
    industry?: string;
    services?: string[];
  };
  context?: string;
}

export interface GeneratedEmailContent {
  subject: string;
  content: string;
  variables: Record<string, string>;
  templateId?: number;
}

export interface EmailTemplateFilters {
  type?: EmailTemplateType;
  search?: string;
  isActive?: boolean;
}